import { NumberRange } from '@app/core/interfaces/c5/number-range';

/**
 * Format a number range in the following format: "Start End Ddi".
 *
 * Start:
 *  * {startCc}{startNdc}{startSn}
 *
 * End (if endCc is defined):
 *  * Case `startCc !== endCc`   => "- {endCc}{endNdc}{endSn}"
 *  * Case `startNdc !== endNdc` => "- {endNdc}{endSn}"
 *  * Otherwise                  => "- {endSn}"
 *
 * Ddi:
 *  * Case `startDdi && endDdi`  => "- {startDdi}-{endDdi}"
 *  * Case `startDdi`            => "- {startDdi}"
 */
export function formatNumberRange(numberRange: NumberRange, includeDdi: boolean = true): string {
  const startNdc = numberRange.startNdc != null ? numberRange.startNdc : '';
  const endNdc = numberRange.endNdc != null ? numberRange.endNdc : '';

  let formatted = `+${numberRange.startCc}${startNdc}${numberRange.startSn}`;

  if (numberRange.endCc) {
    formatted += '-';

    if (numberRange.startCc !== numberRange.endCc) {
      formatted += ` ${numberRange.endCc}${endNdc}${numberRange.endSn}`;
    } else if (startNdc !== endNdc) {
      formatted += ` ${endNdc}${numberRange.endSn}`;
    } else {
      formatted += numberRange.endSn;
    }
  }

  if (includeDdi && numberRange.startDdi) {
    formatted += ` (${numberRange.startDdi}`;

    if (numberRange.endDdi) {
      formatted += `-${numberRange.endDdi}`;
    }

    formatted += ')';
  }

  return formatted;
}
